<template>
    <div class="analyst-stats" :class="upDownColorClass">
        <div class="analyst-stats__item">
            <StarRating :rating="starRating" :language-id="languageId" />
        </div>
        <div class="analyst-stats__item">
            <span class="analyst-stats__value" :class="successRateClass">{{ successRate }}%</span>
            <span class="analyst-stats__label">{{ $t('total_success_rate') }}</span>
        </div>
        <div class="analyst-stats__item">
            <span class="analyst-stats__value" :class="returnClass">{{ formattedReturn }}</span>
            <span class="analyst-stats__label">{{ $t('total_average_return') }}</span>
        </div>
    </div>
</template>

<script >
import { computed } from 'vue-demi';
import StarRating from '../../assets/uis/StarRating.vue';
import { UP_DOWN_COLOR } from '../../common/enum';
import { LanguageId, useI18n } from '../../common/useI18n';
const __sfc_main = {};
__sfc_main.props = {
  starRating: {
    type: Number,
    default: 5
  },
  successRate: {
    type: Number,
    default: 0
  },
  averageReturn: {
    type: Number,
    default: 0
  },
  languageId: {
    type: Number,
    default: LanguageId.EN
  },
  upDownColor: {
    type: Number,
    default: UP_DOWN_COLOR.GREEN_UP
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  // 多语言
  const $t = useI18n(props.languageId);
  const formattedReturn = computed(() => {
    const sign = props.averageReturn >= 0 ? '+' : '';
    return `${sign}${props.averageReturn.toFixed(2)}%`;
  });

  // 涨跌色类名
  const upDownColorClass = computed(() => {
    return props.upDownColor === UP_DOWN_COLOR.RED_UP ? 'analyst-stats--red-up' : 'analyst-stats--green-up';
  });
  const successRateClass = computed(() => {
    if (props.successRate >= 60) return 'analyst-stats__value--positive';
    if (props.successRate < 50) return 'analyst-stats__value--negative';
    return '';
  });
  const returnClass = computed(() => {
    if (props.averageReturn > 0) return 'analyst-stats__value--positive';
    if (props.averageReturn < 0) return 'analyst-stats__value--negative';
    return '';
  });
  return {
    $t,
    formattedReturn,
    upDownColorClass,
    successRateClass,
    returnClass
  };
};
__sfc_main.components = Object.assign({
  StarRating
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="less" scoped>
.analyst-stats {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0.24rem 0;
    border-bottom: 0.02rem solid #f0f0f0;

    &__item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.08rem;
        flex: 1;
    }

    &__value {
        font-size: 0.32rem;
        font-weight: 600;
        color: #333;
        line-height: 1.4;
    }

    &__label {
        font-size: 0.2rem;
        font-weight: 400;
        color: #999;
        line-height: 1.4;
        text-align: center;
    }

    // 绿涨红跌（默认）
    &--green-up {
        .analyst-stats__value--positive {
            color: #52c41a;
        }
        .analyst-stats__value--negative {
            color: #ff4d4f;
        }
    }

    // 红涨绿跌
    &--red-up {
        .analyst-stats__value--positive {
            color: #ff4d4f;
        }
        .analyst-stats__value--negative {
            color: #52c41a;
        }
    }
}
</style>
